import { Component, Input, ViewEncapsulation } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'list-card-item',
  templateUrl: './list-card-item.component.html',
  styleUrls: ['./list-card-item.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ListCardItemComponent {

  @Input() variant = '';
  @Input() syncStatus: boolean | undefined;
  @Input() outline: boolean = false;
  @Input() color='primary';
  @Input() icon = 'help';
  @Input() iconPosition: 'start' | 'end' | 'top-align' = 'start';
  @Input() count = 0;
  @Input() isClickable = false;
  @Input() title!: string | null;
  @Input() lines: string | null = 'show';
  @Input() singleLine: boolean = false;
  @Input() imgSrc: string = '';
  @Input() isVideo: boolean = false;
  identifier = uuidv4() || '';

  constructor() { }

  disablePropagation($event: any) {
    $event.stopPropagation();
  }

}
